import React, { createContext, useContext, useState } from 'react';

const PendingRequestContext = createContext();

export function PendingRequestProvider({ children }) {
  const [pendingCount, setPendingCount] = useState(0);

  const updatePendingCount = (newCount) => {
    setPendingCount(newCount);
  };

  return (
    <PendingRequestContext.Provider value={{ pendingCount, updatePendingCount }}>
      {children}
    </PendingRequestContext.Provider>
  );
}

export const usePendingRequests = () => useContext(PendingRequestContext);